import React from 'react';
import { View } from 'react-native';
import type { TLabelRowProps } from '../../types/softwareLabelTypes';

export const LabelRow = ({ symbol: LabelSymbol, children }: TLabelRowProps) => (
  <View className="flex-row items-start gap-2 mt-2">
    <LabelSymbol />
    <View className="flex-1">{children}</View>
  </View>
);
